export const homeAbout = [
  {
    id: 1,
    cover: "https://img.icons8.com/dotty/80/000000/storytelling.png",
    title: "Gründung",
    desc: "seit dem 15.12.2021 besteht unser PfW streben nach maximaler Lebensqualität ist unsere Philosophie. Wir sind ein sehr familiärer Pflegedienst, der seinen Fokus auf dem Wohl der Kunden legt. Ihr Zuhause ist ihr Reich und das ist uns auch bewusst. ",
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/diploma.png",
    title: "Qualifikationen",
    desc: "Als zugelassener Pflege- und Betreuungsdienst verfügen wir über die Befugnis, mit den Kranken- und Pflegekassen abzurechnen. Diese Qualifikation ermöglicht es uns, eine umfassende und professionelle Versorgung zu gewährleisten, die den individuellen Bedürfnissen unserer Kunden gerecht wird.",
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/athlete.png",
    title: "Unsere Expertise",
    desc: "Wir bieten eine umfassende Palette an Dienstleistungen, die von der alltäglichen Unterstützung über das Anziehen von Kompressionstrümpfen bis hin zur Medikamentengabe und körperlichen Pflege reicht. Unser engagiertes Team steht Ihnen zur Verfügung, um Ihre individuellen Bedürfnisse bestmöglich zu erfüllen.",
  },
]
   
export const online = [
  {
    cover: "./images/JP.webp",
    hoverCover: "./images/JP.webp",
    courseName: "Grundpflege",
    href:"/grundpflege",
    desc:"Unser Pflegedienst bietet umfassende Grundpflege, die auf Ihre individuellen Bedürfnisse zugeschnitten ist. Wir verstehen, dass jeder Mensch einzigartig ist, und deshalb stellen wir sicher, dass unsere Pflege ebenso einzigartig ist. Ob es um Hilfe bei der Körperpflege, Ernährung oder Mobilität geht, unser engagiertes Team ist da, um Sie mit Würde und Respekt zu unterstützen."
  },
  {
    cover: "./images/c.webp",
    hoverCover: "./images/c.webp",
    courseName: "Behandlungspflege",
    href:"/Behandlungspflege",
    desc:"Spezialisiert auf Behandlungspflege, bietet unser Team professionelle Unterstützung in enger Zusammenarbeit mit Ihren Ärzten. Wir kümmern uns um die fachgerechte Durchführung ärztlich verordneter Maßnahmen wie Medikamentengabe, Wundversorgung und Injektionen. Unsere qualifizierten Pflegekräfte sorgen dafür, dass Ihre Gesundheit stets im Mittelpunkt steht."
  },
  {
    cover: "./images/b.webp",
    hoverCover: "./images/BA.webp",
    courseName: "Beratungs nach §37.3",
    href:"/BA",
    desc:"Wir bieten mehr als nur praktische Pflege – unsere Beratungspflege hilft Ihnen und Ihren Angehörigen, den Pflegealltag besser zu verstehen und zu meistern. Unsere Experten stehen bereit, um Fragen zu beantworten, Ratschläge zu geben und Unterstützung bei der Pflegeplanung zu bieten. Bei uns finden Sie einen vertrauensvollen Partner an Ihrer Seite."
  },
  {
    cover: "./images/b.webp",
    hoverCover: "./images/b.webp",
    courseName: "Verhinderungspflege",
    href:"/Vpflege",
    desc:"Unsere Verhinderungspflege stellt sicher, dass Ihre Liebsten auch dann bestens versorgt sind, wenn Sie selbst eine Auszeit brauchen. Wir springen ein, wenn Sie verhindert sind, und bieten eine liebevolle und professionelle Betreuung. Egal ob für ein paar Stunden oder mehrere Tage, wir sind da, um die Kontinuität und Qualität der Pflege zu gewährleisten."

  },
]
export const team = [
  {
    name: "Taimur Malik",
    work: "Geschäftsführer",
  },
  {
    name: "Nicole Sommer",
    work: "Pflegedienstleistung",
  },
]
